module.exports = __webpack_public_path__ + "img/android-logo.95bbbaf5.svg";